import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SelectedLocationType } from 'src/app/enums/selected-location-type.enum';
import { PracticeLocationHeaderService } from '../../services/practice-location-header.service';
import { AsyncPipe } from '@angular/common';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TextTooltipDirective } from '@bioreferencehealth/ui-kit';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';
import { Store } from '@ngxs/store';

@UntilDestroy()
@Component({
  standalone: true,
  selector: 'app-practice-location-header',
  templateUrl: './practice-location-header.component.html',
  styleUrls: ['./practice-location-header.component.scss'],
  imports: [AsyncPipe, TextTooltipDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PracticeLocationHeaderComponent {
  public readonly store: Store = inject(Store);
  private service: PracticeLocationHeaderService = inject(PracticeLocationHeaderService);

  public readonly SelectedLocationType = SelectedLocationType;
  public readonly AppRouteEnum = AppRouteEnum;

  public practiceLocationHeader$ = this.service.practiceLocationHeader$;
  public timeZone$ = this.service.timeZone$;
}
